<template>
  <WalkmanButton
    :model-value="Boolean(modelValue)"
    :options="options"
    :edition-mode="editionMode"
    :disabled="disabled"
    :name="name"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script>
import WalkmanButton from '@c/WalkmanButton.vue'
import { translateWithFallback } from '@c/addressBook/directoryLabels.js'

/**
 * Individual / company switch shared by every contact-like form.
 *
 * Always emits a boolean; parents that store 0/1 convert on their side.
 * Labels reuse `translateWithFallback` from the address book because it is the
 * only existing helper that stands in an existing key for a Lokalise key that
 * has not reached this repository yet.
 */
export default {
  name: 'PersonTypeSwitch',
  components: { WalkmanButton },
  props: {
    modelValue: {
      type: [Boolean, Number],
      default: false
    },
    editionMode: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'is_company'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    options() {
      const translate = (key) => this.$t(key)

      return [
        {
          value: false,
          label: translateWithFallback(
            translate,
            'global.person_type_individual'
          )
        },
        {
          value: true,
          label: translateWithFallback(translate, 'global.person_type_company')
        }
      ]
    }
  }
}
</script>
